<template>
  <div class="app-container">
    <el-row class="card">
      <el-col :span="24">
        <el-form ref="formInline" :inline="true" :model="formInline">
          <el-form-item>
            <el-button
              v-if="$isPermission('agencyRole.create')"
              icon="el-icon-circle-plus-outline"
              @click="createVisibleShow"
            >
              新增
            </el-button>
          </el-form-item>
          <el-form-item label="權限等級" prop="name">
            <el-input v-model="formInline.name" placeholder="權限等級" />
          </el-form-item>
          <el-form-item label="狀態" prop="status">
            <el-select v-model="formInline.status" placeholder="請選擇狀態">
              <el-option label="開啓" :value="1"></el-option>
              <el-option label="關閉" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="創建時間" prop="time">
            <el-date-picker
              v-model="formInline.time"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="~"
              start-placeholder="開始時間"
              end-placeholder="結束時間"
              align="right"
            />
          </el-form-item>

            <el-form-item>
              <el-button  @click="onSubmit">查詢</el-button>
              <el-button style="background: #b6b8bd" @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>
      </el-col>
      <el-col v-loading="loading" :span="24">
        <el-col :span="24">
          <el-table
            highlight-current-row
            :data="tableData"
            style="width: 100%"
            :default-sort="{ prop: sort, order: order }"
            @sort-change="tableSortChange"
          >
            <el-table-column prop="name" label="權限等級"  />
            <el-table-column prop="status" label="狀態" >
              <template slot-scope="{row}">
                  <el-tag :type="row.status == 1?'success':'danger'">{{row.status == 1?'開啓':'關閉'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="創建時間" :formatter="rTime"  />
            <el-table-column prop="updated_at" label="更新時間" :formatter="rTime" />
            <el-table-column label="操作" width="600px">
              <template slot-scope="scope">
                <el-button
                  icon="el-icon-setting"
                  v-if="$isPermission('agencyRole.update')"
                  @click="syncPermissions(scope.row)"
                >
                  權限設置
                </el-button>
                <el-button
                  v-if="$isPermission('agencyRole.update')"
                  style="margin-right: 10px"
                  icon="el-icon-edit-outline"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  編輯
                </el-button>
                <el-popconfirm
                  title="確認刪除?"
                  confirm-button-text="確認"
                  cancel-button-text="取消"
                  @confirm="handleDelete(scope.row.id)"
                >
                  <el-button v-if="$isPermission('agencyRole.delete')" slot="reference" icon="el-icon-delete" type="danger">
                    刪除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" class="margin-t-10" style="text-align: end;margin-top: 20px">
          <el-pagination
            :page-sizes="[10, 25, 50]"
            :page-size="10"
            :current-page="offset"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-col>
    </el-row>
    <el-dialog  title="創建" :visible.sync="createVisible">
      <el-form ref="createForm" :model="createForm" label-width="auto" @submit.native.prevent>
        <el-form-item label="權限等級" prop="name" :error="createError.name ? createError.name[0] : ''">
          <el-input v-model="createForm.name" />
        </el-form-item>
<!--        <el-form-item-->
<!--          :label="$t('role.full_name')"-->
<!--          prop="full_name"-->
<!--          :error="createError.full_name ? createError.full_name[0] : ''"-->
<!--        >-->
<!--          <el-input v-model="createForm.full_name" />-->
<!--        </el-form-item>-->
        <el-form-item
          label="狀態"
          prop="status"
          :error="createError.status ? createError.status[0] : ''"
        >
          <el-radio-group v-model="createForm.status">
            <el-radio :label="1">開啓</el-radio>
            <el-radio :label="2">關閉</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button  :loading="createLoading" @click="onCreate('createForm')">
            儲存
          </el-button>
          <el-button style="background: #b6b8bd" @click="resetCreateForm('createForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog  title="編輯" :visible.sync="updateVisible">
      <el-form ref="updateForm" :model="updateForm" label-width="auto" @submit.native.prevent>
        <el-form-item label="權限等級" prop="name" :error="updateError.name ? updateError.name[0] : ''">
          <el-input v-model="updateForm.name" />
        </el-form-item>
<!--        <el-form-item-->
<!--          :label="$t('role.full_name')"-->
<!--          prop="full_name"-->
<!--          :error="updateError.full_name ? updateError.full_name[0] : ''"-->
<!--        >-->
<!--          <el-input v-model="updateForm.full_name" />-->
<!--        </el-form-item>-->
        <el-form-item
          label="狀態"
          prop="status"
          :error="updateError.status ? updateError.status[0] : ''"
        >
          <el-radio-group v-model="updateForm.status">
            <el-radio :label="1">開啓</el-radio>
            <el-radio :label="2">關閉</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button  :loading="updateLoading" @click="onUpdate('updateForm')">
           儲存
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="syncPermissionsTitle" :visible.sync="syncPermissionsVisible">
      <sync-permissions :id="syncPermissionsId" :visible="syncPermissionsVisible" :success="success" />
    </el-dialog>
  </div>
</template>

<script>
import { rTime } from '@/utils'
import { roles, role, create, update, deleted } from '@/api/index'


export default {
  name: 'Roles',
  components: { SyncPermissions: () => import('@/views/role/syncPermissions.vue') },
  data() {
    return {
      createForm: {
        name: '',
        full_name: '',
        status: 1
      },
      updateForm: {},
      formInline: {
        name: '',
        time: ''
      },
      total: 0,
      loading: true,
      order: 'descending',
      sort: 'created_at',
      offset: 0,
      limit: 10,
      page: 1,
      tableData: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一個月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三個月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      createError: {},
      updateError: {},
      syncPermissionsVisible: false,
      syncPermissionsId: 0,
      syncPermissionsTitle: '',
      createVisible: false,
      updateVisible: false,
      createLoading: false,
      updateLoading: false
    }
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    onUpdate(formName) {
      this.updateError = {}
      this.updateLoading = true
      this.updateForm.full_name = this.updateForm.name
      update(this.updateForm).then(response => {
        if (response.code === 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.updateVisible = false
          this.getRoles()
        }
      }).catch(reason => {
        const { data } = reason.response
        if (data.code === 422) {
          this.updateError = data.data
        }
      }).finally(() => {
        this.updateLoading = false
      })
    },
    createVisibleShow() {
      this.createVisible = true
    },
    onCreate(formName) {
      this.createError = {}
      this.createLoading = true
      this.createForm.full_name = this.createForm.name
      create(this.createForm).then(response => {
        if (response.code === 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.resetCreateForm(formName)
          this.createVisible = false
          this.offset = 0
          this.getRoles()
         this.createForm =  {
            name: '',
              full_name: '',
              status: 1
          }
        }
      }).catch(reason => {
        const { data } = reason.response
        if (data.code === 422) {
          this.createError = data.data
        }
      }).finally(() => {
        this.createLoading = false
      })
    },
    resetCreateForm(formName) {
      this.$refs[formName].resetFields()
    },
    onSubmit() {
      this.offset = 0
      this.page = 1
      this.getRoles()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.offset = 0
      this.page = 1
      this.getRoles()
    },
    tableSortChange(column) {
      this.order = column.order ? column.order : 'descending'
      this.sort = column.prop
      this.offset = 0
      this.page = 1
      this.getRoles()
    },
    getRoles() {
      this.loading = true
      const requestData = {
        offset: this.offset,
        limit: this.limit,
        page: this.page,
        order: this.order,
        sort: this.sort,
        name: this.formInline.name,
        full_name: 'admin',
        created_at: this.formInline.time
      }
      roles(requestData).then(response => {
        const { data } = response
        this.loading = false
        this.tableData = data.list
        this.total = data.total
      }).catch(reason => {
        this.loading = false
        this.tableData = []
        this.total = 0
      })
    },
    handleSizeChange(val) {
      this.limit = val
      this.getRoles()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getRoles()
    },
    rTime(row, column) {
      return rTime(row[column.property])
    },
    handleDelete(id) {
      console.log('aaaaa')
      deleted({
        id: id
      }).then(response => {
        if (response.code === 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.getRoles()
        }
      })
    },
    handleEdit(row) {
      role({
        id: row.id
      }).then(response => {
        this.updateError = {}
        const { data } = response
        this.updateVisible = true
        this.updateForm = data.item
      })
    },
    syncPermissions(row) {
      const { id, name } = row
      this.syncPermissionsId = id
      this.syncPermissionsVisible = true
      this.syncPermissionsTitle = name
    },
    success() {
      this.syncPermissionsId = 0
      this.syncPermissionsVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #FFFFFF;
  margin-top: 20px;
  text-align: start;

}
::v-deep .el-input__inner{
  border: none;
  background: #F8F8F8;
}
.el-button{
  color: #FFFFFF;
  border: none;
  background: #DBBD80;
}
::v-deep .el-range-editor .el-range-input{
  background: transparent;
}
::v-deep .el-dialog{
  width: 650px;
  border-radius: 15px;
  padding: 0;
  position: relative;
}
::v-deep .el-radio-group{
  display: flex;
  align-items: center;
   margin-top: 10px;
}
::v-deep .el-radio__inner {
  width: 18px;
  height: 18px;
  border-radius: 2px;
}

::v-deep .el-radio__label {
  font-size: 18px;

}
::v-deep .el-radio__input.is-checked+.el-radio__label{
  color: #000000;
}

::v-deep .el-radio {
  display: flex;

}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: #000000;
  border-color: #000000;
}

::v-deep .el-radio__input.is-checked .el-radio__inner::after {
  display: none;
}
.el-button--primary{
  background: #409EFF;
}
.el-button--danger{
  background: #F56C6C;
}
</style>
